import { renderElement } from "../../utils/use-render.js";
import { useSliderContext, useSliderPointerValue } from "../slider/context.js";
import { SliderSegmentsCore, TimeSliderChapterCSSVars } from "@videojs/core";
import { getStateDataAttrs } from "@videojs/core/dom";
import { Fragment, forwardRef, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/time-slider/segments.tsx
/** Private React adapter for rendering normalized numeric slider segments. */
const SliderSegments = forwardRef(function SliderSegments(componentProps, ref) {
	const { ranges, min, max, renderSegment, render, className, style, ...elementProps } = componentProps;
	const slider = useSliderContext();
	const pointerValue = useSliderPointerValue();
	const [core] = useState(() => new SliderSegmentsCore());
	const geometry = useMemo(() => core.getGeometry({
		ranges,
		min,
		max,
		orientation: slider.state.orientation
	}), [
		core,
		ranges,
		min,
		max,
		slider.state.orientation
	]);
	const sliderAttrs = getStateDataAttrs(slider.state, slider.stateAttrMap);
	const segments = geometry.map((segment) => {
		const state = core.getState(segment, slider.state, pointerValue);
		const segmentStyle = {
			[TimeSliderChapterCSSVars.start]: state.startPercent,
			[TimeSliderChapterCSSVars.end]: state.endPercent,
			[TimeSliderChapterCSSVars.width]: state.width ?? state.height,
			[TimeSliderChapterCSSVars.fill]: `${state.fillPercent}%`
		};
		return /* @__PURE__ */ jsx(Fragment, { children: renderSegment({
			...sliderAttrs,
			style: segmentStyle
		}, state) }, state.key);
	});
	const state = geometry.length > 0 ? core.getState(geometry[0], slider.state, pointerValue) : null;
	if (!state) return null;
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		ref,
		props: [
			{ "aria-hidden": "true" },
			sliderAttrs,
			elementProps,
			{ children: segments }
		]
	});
});
//#endregion
export { SliderSegments };

//# sourceMappingURL=segments.js.map